// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.customAutoSuggestContainer {
    flex-grow: 1;
}

.customAutoSuggestInput {
    width: 100%;
    padding: 9px 18px;
    font-size: 16px;
    font-weight: 400;
    line-height: 26px;
    color: var(--primary-foreground);
    border: unset;
    outline: unset;
    background: var(--primary-input-bg);
    border-radius: 4px 0 0 4px;
}

.customAutoSuggestInput::placeholder {
    color: var(--primary-placeholder-foreground);
}

.customAutoSuggestionBox {
    max-height: 260px;
    width: 100%;
    position: absolute;
    top: 44px;
    border: unset;
    background-color: var(--primary-input-bg);
    box-shadow: 0px 4px 10px 0px var(--shadow-5);
    border-radius: 4px;
    z-index: 2;
    overflow-y: auto;
}

.customAutoSuggestListContainer {
    margin: 0;
    padding: 0;
    list-style-type: none;
}

.customAutoSuggestList {
    padding: 12px 18px;
    font-size: 16px;
    font-weight: 400;
    line-height: 26px;
    color: var(--primary-foreground);
    border-bottom: 1px solid var(--primary-border);
    cursor: pointer;
    text-align: start;
    cursor: pointer;
}

.customAutoSuggestListHighlight {
    background: var(--common-hover-bg);
    border-radius: 4px;
}


/* only autosuggest rtl */
.rtl .customAutoSuggestInput {
    border-radius: 0 4px 4px 0;
}`, "",{"version":3,"sources":["webpack://./src/styles/autoSuggestSearch.css"],"names":[],"mappings":"AAAA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gCAAgC;IAChC,aAAa;IACb,cAAc;IACd,mCAAmC;IACnC,0BAA0B;AAC9B;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,aAAa;IACb,yCAAyC;IACzC,4CAA4C;IAC5C,kBAAkB;IAClB,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,UAAU;IACV,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gCAAgC;IAChC,8CAA8C;IAC9C,eAAe;IACf,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,kCAAkC;IAClC,kBAAkB;AACtB;;;AAGA,yBAAyB;AACzB;IACI,0BAA0B;AAC9B","sourcesContent":[".customAutoSuggestContainer {\n    flex-grow: 1;\n}\n\n.customAutoSuggestInput {\n    width: 100%;\n    padding: 9px 18px;\n    font-size: 16px;\n    font-weight: 400;\n    line-height: 26px;\n    color: var(--primary-foreground);\n    border: unset;\n    outline: unset;\n    background: var(--primary-input-bg);\n    border-radius: 4px 0 0 4px;\n}\n\n.customAutoSuggestInput::placeholder {\n    color: var(--primary-placeholder-foreground);\n}\n\n.customAutoSuggestionBox {\n    max-height: 260px;\n    width: 100%;\n    position: absolute;\n    top: 44px;\n    border: unset;\n    background-color: var(--primary-input-bg);\n    box-shadow: 0px 4px 10px 0px var(--shadow-5);\n    border-radius: 4px;\n    z-index: 2;\n    overflow-y: auto;\n}\n\n.customAutoSuggestListContainer {\n    margin: 0;\n    padding: 0;\n    list-style-type: none;\n}\n\n.customAutoSuggestList {\n    padding: 12px 18px;\n    font-size: 16px;\n    font-weight: 400;\n    line-height: 26px;\n    color: var(--primary-foreground);\n    border-bottom: 1px solid var(--primary-border);\n    cursor: pointer;\n    text-align: start;\n    cursor: pointer;\n}\n\n.customAutoSuggestListHighlight {\n    background: var(--common-hover-bg);\n    border-radius: 4px;\n}\n\n\n/* only autosuggest rtl */\n.rtl .customAutoSuggestInput {\n    border-radius: 0 4px 4px 0;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
